export default __webpack_public_path__ + "static/media/Quarteto-de-cordas.d9925078.mp3";